<template>
  <div class="auth-page">
    <UcariHeader />
    <main class="system-page"><section class="system-card">
      <span class="system-card__icon" uk-spinner v-if="loading"></span>
      <span class="eyebrow">Account verification</span>
      <h1>{{ loading ? 'Verifying your email' : 'Email verification' }}</h1>
      <p v-if="loading">Please wait while we securely verify your link.</p>
      <div v-if="error" class="uk-alert-danger">{{ error }}</div>
      <div v-if="success"><p>{{ success }}</p><router-link to="/login" class="uk-button uk-button-primary">Sign in</router-link></div>
    </section></main>
    <RetailerFooter />
  </div>
</template>

<script>
import UcariHeader from './components/UcariHeader.vue';
import RetailerFooter from './components/RetailerFooter.vue';

export default {
  components: { UcariHeader, RetailerFooter },
  data() {
    return {
      loading: true,
      error: null,
      success: null,
    };
  },
  async created() {
    document.title = 'Partner Account Verify Email | UCARI';

    const token = this.$route.query.token;
    const mode = this.$route.query.mode;

    const endpoint =
      mode === 'email-change'
        ? '/api/verify-email-change'
        : '/api/verify-email';

    if (!token) {
      this.error = 'Verification token is missing.';
      this.loading = false;
      return;
    }

    const url = `${process.env.VUE_APP_API_URL}${endpoint}?token=${encodeURIComponent(token)}`;
    window.location.assign(url);
  },
};
</script>
